import React from "react";
import { forwardRef } from "react";
import {
  StyledMatrixForDownloadContainer,
  StyledMatrixForDownloadContent,
  StyledMatrixForDownloadHeader,
  StyledMatrixForDownloadTitle,
  StyledMatrixForDownloadSubtitle,
} from "./MatrixForDownload.styled";

type SubtitleItem = {
  label: string;
  value: string;
};

type MatrixForDownloadProps = {
  year: number;
  title: string;
  subtitleItems: SubtitleItem[];
  children: React.ReactNode;
};

const MatrixForDownload = forwardRef<HTMLDivElement, MatrixForDownloadProps>(
  ({ year, title, subtitleItems, children }, ref) => {
    return (
      <StyledMatrixForDownloadContainer ref={ref}>
        <StyledMatrixForDownloadContent>
          <StyledMatrixForDownloadHeader>
            <StyledMatrixForDownloadTitle>
              {title} {year}
            </StyledMatrixForDownloadTitle>
            {subtitleItems.map((item, index) => (
              <StyledMatrixForDownloadSubtitle key={index}>
                <strong>{item.label}:</strong> {item.value}
              </StyledMatrixForDownloadSubtitle>
            ))}
          </StyledMatrixForDownloadHeader>
          {children}
        </StyledMatrixForDownloadContent>
      </StyledMatrixForDownloadContainer>
    );
  },
);

export default MatrixForDownload;
